import { render, staticRenderFns } from "./fmSingleRelease.vue?vue&type=template&id=21b81116&"
import script from "./fmSingleRelease.vue?vue&type=script&lang=js&"
export * from "./fmSingleRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b81116')) {
      api.createRecord('21b81116', component.options)
    } else {
      api.reload('21b81116', component.options)
    }
    module.hot.accept("./fmSingleRelease.vue?vue&type=template&id=21b81116&", function () {
      api.rerender('21b81116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/fmSingleRelease.vue"
export default component.exports